"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GoogledriveIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.81 3-6.776.068 5.846 10.126 6.777-.07zM2 14.315l3.447 5.835 5.846-10.126L7.846 4.19zm8.307.175-3.33 5.902H18.67L22 14.49z"/></svg>`
}, props));
GoogledriveIcon.displayName = 'GoogledriveIcon';
var _default = exports.default = GoogledriveIcon;